import { BoxesKey } from 'home/useBoxes';
import { queryCache } from 'react-query';
import { AdminBoxesKey } from './useAdminBoxes';

const invalidateBoxQueries = async () => {
  await queryCache.invalidateQueries(AdminBoxesKey, { refetchInactive: true });
  await queryCache.invalidateQueries(BoxesKey, { refetchInactive: true });
};

export default invalidateBoxQueries;
